<template>
  <Modal v-model="cancelCustomizedProductOrdersModal" :title="cancelCustomizedProductOrdersTitle" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="cancelCustomizedProductOrdersChange">
    <div class="flex align-items-start mb15" v-if="cancelCustomizedProductOrdersType !== 'ymsAllowCancel'">
      <span class="red-dot">{{ $t('key1001071') }}</span>
      <Input v-model.trim="invalidReason" :placeholder="$t('key1001068')" type="textarea" :rows="5" style="width:500px;"></Input>
    </div>
    <template v-if="payStatus !== 1">
      <template v-if="system === 'yms'">
        <h2 class="mb15 font-weight-bold font-size-14 color-333">
          <span>{{ $t('key1001072') }}</span>
          <span class="themeColor">{{ ymsSkuList.join('、') }}</span>
          <span>{{ $t('key1001073') }}</span>
        </h2>
        <div class="flex align-items-center mb8">
          <span>{{ $t('key1001074') }}</span>
          <RadioGroup v-model="processingStatus">
            <Radio :label="2" class="mr30">{{ $t('key1001075') }}</Radio>
            <Radio :label="1">{{ $t('key1001076') }}</Radio>
          </RadioGroup>
        </div>
        <p class="font-size-13 color-666 mb15">{{ processingDescription }}</p>
        <template v-if="cancelPrice">
          <div class="mb20">
            {{ $t('key1001077') }}
            <span class="themeColor ml3 mr4">{{ timer }}</span>
            {{ $t('key1001078') }}
            <span class="themeColor">{{ $t('key1001070') + cancelPrice + ' ' + currencyState }}</span>
            {{ $t('key1001079') }}
          </div>
        </template>
        <div class="flex align-items-center mb15">
          <span class="themeColor">{{ $t('key1000233') }}</span>
          <span class="mr40">{{ formatCurrency(originalCost) + ' ' + currencyState + '；' }}</span>
          <span class="redColor">{{ $t('key1000234') }}</span>
          <span>{{ formatCurrency(refundAmount) + ' ' + currencyState }}</span>
        </div>
        <div class="flex align-items-center mb15">
          <span>{{ $t('key1001080') }}</span>
          <InputNumber style="width: 180px" :min="0" :max="refundAmount" :placeholder="$t('key1001069')"
            :formatter="(value) => formatterNumber(value, 2)" v-model.trim="cancellationFee">
          </InputNumber>
          <span class="ml5">{{ '(' + currencyState + ')' }}</span>
        </div>
      </template>
      <template v-else>
        <h2 class="mb15 font-size-14">
          <span>{{ $t('key1001081') }}</span>
          <span class="distributorThemeColor">{{ ymsSkuList.join('、') }}</span>
          <span>{{ processingTxt }}</span>
        </h2>
        <template v-if="cancelPrice === 0">
          <div class="mb20">
            {{ $t('key1001077') }}
            <span class="distributorThemeColor ml3 mr4">{{ timer }}</span>
            {{ $t('key1001078') }}
            <span class="distributorThemeColor">{{ $t('key1001070') + cancelPrice + ' ' + currencyState }}</span>
            {{ $t('key1001079') }}
          </div>
        </template>
        <div class="flex align-items-center flex-wrap mb15">
          <span class="distributorThemeColor">{{ $t('key1000233') }}</span>
          <span class="mr15">{{ formatCurrency(originalCost) + currencyState + '；' }}</span>
          <template v-if="processingStatus === 2">
            <span class="distributorThemeColor">{{ $t('key1001082') }}</span>
            <span class="mr15">{{ formatCurrency(customizedProductCost) + ' ' + currencyState + '；' }}</span>
          </template>
          <span class="distributorThemeColor">{{ $t('key1001070') }}</span>
          <span class="mr15">{{ formatCurrency(cancelPrice) + ' ' + currencyState + '；' }}</span>
          <div class="flex align-items-center mt5">
            <span class="distributorThemeColor">{{ $t('key1001080') }}</span>
            <span>{{ formatCurrency(invalidHandlerCost) + ' ' + currencyState + '；' }}</span>
          </div>
        </div>
        <div class="flex align-items-center mb15">
          <span class="distributorThemeColor">{{ $t('key1001083') }}</span>
          <span>{{ formatCurrency(totalRefund) + ' ' + currencyState + '；' }}</span>
        </div>
      </template>
    </template>
    <template #footer>
      <Button @click="cancelCustomizedProductOrdersModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="cancelCustomizedProductOrdersBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {calculateDiffTime, formatterNumber, getOrderLogisticsConsumption, isValueEmpty} from "@/utils/common";

export default {
  name: 'cancelCustomizedProductOrdersModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      cancelCustomizedProductOrdersModal: false,
      cancelCustomizedProductOrdersTitle: '',
      cancelCustomizedProductOrdersType: null,
      ymsSkuList: [],
      customizedTitle: null,
      processingStatus: 2, // 1待加工，2加工中，3加工完成
      originalCost: null, // 订单原费用
      cancellationFee: null, // 取消手续费
      customizedProductCost: null, // 定制商品费用
      invalidReason: '', // 取消原因
      customizedProductsList: [],
      ymsPackageId: null,
      invalidHandlerCost: null, // 处理手续费
      detailData: {},
      cancelPrice: 0,
      timer: null,
      payStatus: null
    };
  },
  computed: {
    processingDescription() {
      return this.processingStatus === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001060') :
        this.processingStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001061') : '-';
    },
    processingTxt() {
      return this.processingStatus === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001062') :
        this.processingStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001063') : '-';
    },
    // 退款金额
    refundAmount() {
      let value = 0;
      if (this.processingStatus === 2) {
        value = this.originalCost - this.customizedProductCost - this.cancelPrice;
      }
      if (this.processingStatus === 1) {
        value = this.originalCost - this.cancelPrice;
      }
      return Number(value.toFixed(2));
    },
    // 总退费
    totalRefund() {
      let value = 0;
      if (this.processingStatus === 2) {
        value = this.originalCost - this.customizedProductCost - this.invalidHandlerCost - this.cancelPrice;
      }
      if (this.processingStatus === 1) {
        value = this.originalCost - this.invalidHandlerCost - this.cancelPrice;
      }
      return Number(value.toFixed(2)) || 0;
    }
  },
  methods: {
    formatterNumber,
    // 初始化数据
    initCancelCustomizedProductOrdersData(type, obj) {
      this.payStatus = obj.payStatus || null;
      if (this.system === 'distributor') {
        this.processingStatus = Number(obj.processingStatus);
        this.invalidHandlerCost = obj.invalidHandlerCost || 0;
      } else {
        this.processingStatus = Number(obj.processingStatus);
        this.cancellationFee = isValueEmpty(obj.invalidHandlerCost) ? null : obj.invalidHandlerCost;
      }
      this.cancelCustomizedProductOrdersTitle = type === 'ymsAllowCancel' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001064') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001065');
      this.cancelCustomizedProductOrdersType = type;
      this.ymsPackageId = obj.ymsPackageId;
      this.originalCost = obj.totalPrice;
      this.detailData = obj;
      let ymsPackageGoodsList = obj.ymsPackageGoods || [];
      this.customizedProductsList = ymsPackageGoodsList.filter((item) => item.isNeedCustomization === 1);
      if (this.customizedProductsList.length > 0) {
        this.ymsSkuList = this.customizedProductsList.map((item) => {
          return item.ymsSku;
        });
      }
      // 定制商品费用
      this.customizedProductCost = this.customizedProductsList.reduce((sum, item) => {
        const quantity = item.quantity || 0;
        const cost = item.productGoodsCost || 0;
        return sum + quantity * cost;
      }, 0);

      getOrderLogisticsConsumption(obj.ymsPackageId).then((data) => {
        if (data) {
          this.cancelPrice = data.cancelPrice || 0;
          let trackingNumberTime = obj.trackingNumberTime || '';
          if (trackingNumberTime) {
            trackingNumberTime = this.$uDate.dealTime(trackingNumberTime, 'fulltime');
            this.timer = calculateDiffTime(trackingNumberTime);
          }
        }
      });
      this.cancelCustomizedProductOrdersModal = true;
    },
    // 确定
    cancelCustomizedProductOrdersBtn() {
      let query = {};
      if (this.cancelCustomizedProductOrdersType !== 'ymsAllowCancel') {
        if (!this.invalidReason) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001066'));
          return false;
        }
      }
      switch (this.cancelCustomizedProductOrdersType) {
        //运营--允许取消订单
        case 'ymsAllowCancel':
          query = {
            invalidhandlerCost: this.cancellationFee,
            invalidhandlerCostCurrency: this.currencyState,
            ymsPackageIds: [this.ymsPackageId],
            processingStatus: this.processingStatus
          };
          this.axios.put(api.put_ymsPackageInfo_invalidConfirm, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.cancelCustomizedProductOrdersModal = false;
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              this.$emit('cancelOrderSuccess', true);
            }
          });
          break;
        // 运营--取消订单
        case 'ymsCancelOrder':
          query = {
            ymsPackageId: this.ymsPackageId,
            invalidReason: this.invalidReason,
          };
          if (this.payStatus !== 1) {
            query.processingStatus = this.processingStatus;
            query.invalidHandlerCost = this.cancellationFee;
            query.invalidHandlerCostCurrency = this.currencyState;
          } else {
            query.processingStatus = 1;
          }
          this.axios.post(api.post_ymsPackageInfo_cancelPackageInfo, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001067'));
              this.cancelCustomizedProductOrdersModal = false;
              this.$emit('cancelOrderSuccess', true);
            }
          });
          break;
        // 分销商-yms订单-取消订单
        case 'distributorCancelOrder':
          query = {
            invalidPlatformOrderSkusBos: [],
            invalidType: 0,
            invalidReason: this.invalidReason,
            isHand: this.detailData.isHand,
            packageCode: this.detailData.packageCode,
            ymsPackageId: this.detailData.ymsPackageId,
            ymsPlatformOrderId: this.detailData.ymsPlatformOrderId
          };
          this.axios.post(api.post_ymsDistributorPackageInfo_cancelPackage, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001067'));
              this.cancelCustomizedProductOrdersModal = false;
              this.$emit('cancelYmsOrderSuccess', data);
            }
          });
          break;
        // 分销商--平台订单详情--取消yms订单
        case 'platformOrderDetailsCancelOrder':
          query = {
            orderShippingId: this.detailData.ymsPlatformOrderShippingId,
            invalidReason: this.invalidReason,
            ymsPlatformOrderId: this.detailData.ymsPlatformOrderId
          };
          this.axios.post(api.post_ymsPlatformOrder_cancelOrderYms, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001067'));
              this.cancelCustomizedProductOrdersModal = false;
              this.$emit('cancelYmsOrderSuccess', data);
            }
          });
          break;
      }
    },
    // 监听弹窗
    cancelCustomizedProductOrdersChange(value) {
      if (!value) {
        this.customizedTitle = null;
        this.customizedProductsList = [];
        this.ymsPackageId = null;
        this.invalidReason = '';
        this.processingStatus = 2;
        this.originalCost = null;
        this.cancellationFee = null;
        this.ymsSkuList = [];
        this.invalidHandlerCost = null;
        this.detailData = {};
        this.cancelPrice = 0;
        this.timer = null;
        this.payStatus = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
